/**
 * Shared share-code helpers.
 *
 * A share code is an 8-character alphanumeric string split visually after the
 * 4th character (e.g. `3J2L-B5EB`). Everywhere in the app that shows or
 * consumes a share code should go through these two helpers so the format
 * stays consistent.
 */
/** Strip non-alphanumerics, uppercase, truncate to 8 chars. */
export function normalizeShareCode(raw) {
    return (raw !== null && raw !== void 0 ? raw : '')
        .replace(/[^A-Za-z0-9]/g, '')
        .toUpperCase()
        .slice(0, 8);
}
/**
 * Display format: uppercase alphanumerics + a separator inserted after the
 * 4th character. Defaults to a single hyphen (`3J2L-B5EB`). Pass ` - ` for
 * the spaced form used inside the EnterKey input.
 */
export function formatShareCode(raw, separator) {
    if (separator === void 0) { separator = '-'; }
    var cleaned = normalizeShareCode(raw);
    if (cleaned.length <= 4)
        return cleaned;
    return cleaned.slice(0, 4) + separator + cleaned.slice(4, 8);
}
